import { render } from "./StaffForm.vue?vue&type=template&id=a3696b74&scoped=true"
import script from "./StaffForm.vue?vue&type=script&lang=js"
export * from "./StaffForm.vue?vue&type=script&lang=js"

import "./StaffForm.vue?vue&type=style&index=0&id=a3696b74&scoped=true&lang=css"
import "./StaffForm.vue?vue&type=style&index=1&id=a3696b74&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3696b74"]])

export default __exports__